import AddOutlined from '@mui/icons-material/AddOutlined';
import { SupportCardShell, MessageThread } from '@practium/features/support';
import type { SupportTicketDTO } from '@practium/features/support';
import { TicketStatus } from '@practium/features/support';
import styles from './SupportTicketCard.module.css';
import { useState } from 'react';

interface SupportTicketCardProps {
	ticket: SupportTicketDTO;
	userName: string;
	avatarUrl?: string;
	onReply: (ticket: SupportTicketDTO) => void;
}

export const SupportTicketCard = ({
	ticket,
	userName,
	avatarUrl,
	onReply,
}: SupportTicketCardProps) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const createdAt = ticket.createdAt ? new Date(ticket.createdAt) : new Date();
	const messages = ticket.messages ?? [];
	const lastMessage = messages[0];
	const canReply = ticket.status !== TicketStatus.Closed;

	const headerActions = canReply ? (
		<button
			type="button"
			className={styles.actionBtn}
			onClick={() => onReply(ticket)}
			aria-label="Adicionar mensagem"
		>
			<AddOutlined className={styles.actionIcon} />
		</button>
	) : undefined;

	const expandedContent = <MessageThread messages={messages} />;

	return (
		<SupportCardShell
			avatarUrl={avatarUrl}
			userName={userName}
			subject={ticket.subject}
			createdAt={createdAt}
			isExpanded={isExpanded}
			onExpand={() => setIsExpanded((p) => !p)}
			headerActions={headerActions}
			preview={lastMessage?.content}
			expandedContent={expandedContent}
		/>
	);
};
